function Gallery({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width="${dimensions || '72'}" height="${dimensions || '72'}" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M64 8V64H8V8H64ZM64 0H8C3.6 0 0 3.6 0 8V64C0 68.4 3.6 72 8 72H64C68.4 72 72 68.4 72 64V8C72 3.6 68.4 0 64 0ZM44.56 35.44L32.56 50.92L24 40.56L12 56H60L44.56 35.44Z" fill="${col}"/>
    </svg>
  `;

  return baseXml;
}

export default Gallery;
